export const markdownToFile = (text: string, filename = 'data') => {
  // Create a Blob from the string
  const blob = new Blob([text], { type: 'text/markdown' });

  // Create a file from the Blob (optional)
  const file = new File([blob], `${filename}.md`, { type: 'text/markdown' });

  return file;
};
